import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Typography, makeStyles, Box } from '@material-ui/core';
import GraduationRate from './GraduationRate';
import FirstYearReturn from './FirstYearReturn';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    marginBottom: theme.spacing(1),
  },
  summary: {
    background: theme.palette.background.default,
  },
  details: {
    border: '1px solid rgba(105, 109, 117, 0.15)',
    justifyContent: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    }
  },
  chart: {
    padding: theme.spacing(4),
  },
}));

const Retention = ({ school }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Accordion elevation={0}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          className={classes.summary}
          IconButtonProps={{
            edge: 'start',
            color: 'inherit',
          }}
        >
          <Typography variant="body2">
            Graduation & Retention
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <Box display="flex" flexDirection="column" alignItems="center" flex={1}>
            <GraduationRate cx={100} cy={100} school={school} />
          </Box>
          <Box display="flex" flexDirection="column" alignItems="center" flex={1}>
            <FirstYearReturn cx={100} cy={100} school={school} />
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Retention;
